// 📄 tv-report-pdf.tsx
import React from "react";
import { Document, Page, Text, View, Image, StyleSheet } from "@react-pdf/renderer";
import { format } from "date-fns";

const statusColors: Record<string, string> = {
    acknowledged: "#4caf50",
    pending: "#ff9800",
    duplicate: "#2196f3",
    rejected: "#f44336",
};

const styles = StyleSheet.create({
    page: { padding: 30, fontSize: 12, fontFamily: "Helvetica" },
    headerTitle: { fontSize: 20, marginBottom: 20, fontWeight: "normal" },
    sectionTitle: { fontSize: 14, marginBottom: 8, fontWeight: "normal" },
    statusRow: { flexDirection: "row", alignItems: "center", marginBottom: 12 },
    statusBox: { padding: 5, borderRadius: 4, color: "white", fontSize: 10, marginRight: 10 },
    row: { flexDirection: "row", marginBottom: 6 },
    label: { width: 160, fontSize: 11, fontWeight: "bold" },
    value: { flex: 1, fontSize: 11 },
    banner: { width: "100%", height: "auto", marginBottom: 20 },
    attachmentsContainer: { flexDirection: "row", flexWrap: "wrap", marginTop: 10 },
    attachmentImage: { width: 180, height: 120, marginRight: 10, marginBottom: 10 },
    noAttachmentText: { fontSize: 11, color: "gray", marginTop: 10 }
});

const DataRow = ({ label, value }: { label: string; value: string }) => (
    <View style={styles.row}>
        <Text style={styles.label}>{label}</Text>
        <Text style={styles.value}>{value}</Text>
    </View>
);

const TVReportPDF: React.FC<{ report: any }> = ({ report }) => {
    const deputy = report.user;
    const attachments = report.attachments || [];
    const images = attachments.filter((item: any) => item.type === "IMAGE").slice(0, 4);
    const statusColor = statusColors[report.report_status.toLowerCase()] || "grey";

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Image src={`${process.env.PUBLIC_URL}/pdf-banner.jpg`} style={styles.banner} />

                <Text style={styles.headerTitle}>TV Report</Text>

                <View style={styles.statusRow}>
                    <Text style={{ ...styles.statusBox, backgroundColor: statusColor }}>
                        {report.report_status}
                    </Text>
                    <Text
                        style={{
                            fontSize: 11,
                            color: report.has_violation ? "red" : "grey",
                            fontWeight: "bold"
                        }}
                    >
                        {report.has_violation ? "With Violation" : "Without Violation"}
                    </Text>
                </View>

                <Text style={styles.sectionTitle}>Report Details</Text>
                <DataRow label="Report ID:" value={report.id} />
                <DataRow
                    label="Date and Time of Report:"
                    value={format(new Date(report.created_at), "MMMM dd, yyyy - h:mm a")}
                />

                <Text style={[styles.sectionTitle, { marginTop: 12 }]}>Deputy Info</Text>
                <DataRow label="Fullname:" value={`${deputy.name} ${deputy.last_name}`} />
                <DataRow label="Email:" value={deputy.email} />
                <DataRow label="Contact:" value={deputy.phone_number} />

                <Text style={[styles.sectionTitle, { marginTop: 12 }]}>Admin Info</Text>
                <DataRow
                    label="Fullname:"
                    value={report.admin ? `${report.admin.name} ${report.admin.last_name}` : "None"}
                />
                <DataRow label="Status:" value={report.report_status} />

                <Text style={[styles.sectionTitle, { marginTop: 12 }]}>Report Info</Text>
                <DataRow label="Name of Television Network:" value={report.tv_network} />
                <DataRow label="Title of Television Program:" value={report.tv_program} />
                <DataRow
                    label="Date & Time of Program Aired:"
                    value={format(new Date(report.program_datetime), "MMMM dd, yyyy - h:mm a")}
                />
                <DataRow
                    label="Brief description:"
                    value={report.comments || "N/A"}
                />


            </Page>
        </Document>
    );
};

export default TVReportPDF;
